import { API_URL } from "../constants";
import { apiRequest } from "./apiRequest";

export const getUrl = () => `${API_URL}/api/v1/admin/report/sales`;

const getReportSales = async () => await apiRequest(getUrl(), "get");

export default getReportSales;

